module.exports = __webpack_public_path__ + "static/media/aboutSection1pic.8873dfc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutSection1pic.jpg
// module id = 105
// module chunks = 0